import isMobile from "ismobilejs";
import dom from "./dom";
import mode from "./mode";
import g from "./globals";

const getFeatures = () => {
  const isMobEnv = g.channels.mobile || /-mob/.test(window.location.href);
  let features = {
    touch: isMobile(window.navigator).phone || isMobile(window.navigator).tablet || (g.editMode && (isMobEnv || g.isTablet)),
    phone: isMobile(window.navigator).phone || (g.editMode && isMobEnv),
    tablet: isMobile(window.navigator).tablet || (g.editMode && g.isTablet),
  };
  if (g.developerMode) {
    if (mode.query.device) {
      if (mode.query.device.indexOf("ipad") > -1) {
        features = {
          touch: true,
          phone: false,
          tablet: true,
        };
      } else if (mode.query.device === "mobile" || mode.query.device === "apps") {
        features = {
          touch: true,
          phone: true,
          tablet: false,
        };
      }
    }
  }
  if (g.editMode && g.channel) {
    if (g.isTablet) {
      features = {
        touch: true,
        phone: false,
        tablet: true,
      };
    } else if (g.channel !== "desktop") {
      features = {
        touch: true,
        phone: true,
        tablet: false,
      };
    }
  }
  return features;
};

export const features = getFeatures();

const html = document.documentElement;

export const setFeatures = () => {
  for (const [feature, active] of Object.entries(getFeatures())) {
    const classToAdd = active ? feature : `no-${feature}`;
    const classToRemove = active ? `no-${feature}` : feature;
    dom.addClass(html, classToAdd);
    dom.removeClass(html, classToRemove);
  }
};
